import { render, staticRenderFns } from "./PasswordForgot.vue?vue&type=template&id=8884afa8&scoped=true"
import script from "./PasswordForgot.vue?vue&type=script&lang=ts"
export * from "./PasswordForgot.vue?vue&type=script&lang=ts"
import style0 from "./PasswordForgot.vue?vue&type=style&index=0&id=8884afa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8884afa8",
  null
  
)

export default component.exports